module.exports = __webpack_public_path__ + "static/img/i-c-bio.9de23a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/home/i-c-bio.png
// module id = AtDd
// module chunks = 1